export const HARDCODED_LANGUAGES = [
  {
    Name: 'Abkhazian',
    Value: 'ABK',
  },
  {
    Name: 'Achinese',
    Value: 'ACE',
  },
  {
    Name: 'Acoli',
    Value: 'ACH',
  },
  {
    Name: 'Adangme',
    Value: 'ADA',
  },
  {
    Name: 'Adyghe; Adygei',
    Value: 'ADY',
  },
  {
    Name: 'Afar',
    Value: 'AAR',
  },
  {
    Name: 'Afrihili',
    Value: 'AFH',
  },
  {
    Name: 'Afrikaans',
    Value: 'AFR',
  },
  {
    Name: 'Afro-Asiatic languages',
    Value: 'AFA',
  },
  {
    Name: 'Ainu',
    Value: 'AIN',
  },
  {
    Name: 'Akan',
    Value: 'AKA',
  },
  {
    Name: 'Akkadian',
    Value: 'AKK',
  },
  {
    Name: 'Albanian',
    Value: 'SQI',
  },
  {
    Name: 'Aleut',
    Value: 'ALE',
  },
  {
    Name: 'Algonquian languages',
    Value: 'ALG',
  },
  {
    Name: 'Altaic languages',
    Value: 'TUT',
  },
  {
    Name: 'Amharic',
    Value: 'AMH',
  },
  {
    Name: 'Angika',
    Value: 'ANP',
  },
  {
    Name: 'Apache languages',
    Value: 'APA',
  },
  {
    Name: 'Arabic',
    Value: 'ARA',
  },
  {
    Name: 'Aragonese',
    Value: 'ARG',
  },
  {
    Name: 'Arapaho',
    Value: 'ARP',
  },
  {
    Name: 'Arawak',
    Value: 'ARW',
  },
  {
    Name: 'Armenian',
    Value: 'HYE',
  },
  {
    Name: 'Aromanian; Arumanian; Macedo-Romanian',
    Value: 'RUP',
  },
  {
    Name: 'Artificial languages',
    Value: 'ART',
  },
  {
    Name: 'Assamese',
    Value: 'ASM',
  },
  {
    Name: 'Asturian; Bable; Leonese; Asturleonese',
    Value: 'AST',
  },
  {
    Name: 'Athapascan languages',
    Value: 'ATH',
  },
  {
    Name: 'Australian languages',
    Value: 'AUS',
  },
  {
    Name: 'Austronesian languages',
    Value: 'MAP',
  },
  {
    Name: 'Avaric',
    Value: 'AVA',
  },
  {
    Name: 'Avestan',
    Value: 'AVE',
  },
  {
    Name: 'Awadhi',
    Value: 'AWA',
  },
  {
    Name: 'Aymara',
    Value: 'AYM',
  },
  {
    Name: 'Azerbaijani',
    Value: 'AZE',
  },
  {
    Name: 'Balinese',
    Value: 'BAN',
  },
  {
    Name: 'Baltic languages',
    Value: 'BAT',
  },
  {
    Name: 'Baluchi',
    Value: 'BAL',
  },
  {
    Name: 'Bambara',
    Value: 'BAM',
  },
  {
    Name: 'Bamileke languages',
    Value: 'BAI',
  },
  {
    Name: 'Banda languages',
    Value: 'BAD',
  },
  {
    Name: 'Bantu languages',
    Value: 'BNT',
  },
  {
    Name: 'Basa',
    Value: 'BAS',
  },
  {
    Name: 'Bashkir',
    Value: 'BAK',
  },
  {
    Name: 'Basque',
    Value: 'EUS',
  },
  {
    Name: 'Batak languages',
    Value: 'BTK',
  },
  {
    Name: 'Beja; Bedawiyet',
    Value: 'BEJ',
  },
  {
    Name: 'Belarusian',
    Value: 'BEL',
  },
  {
    Name: 'Bemba',
    Value: 'BEM',
  },
  {
    Name: 'Bengali',
    Value: 'BEN',
  },
  {
    Name: 'Berber languages',
    Value: 'BER',
  },
  {
    Name: 'Bhojpuri',
    Value: 'BHO',
  },
  {
    Name: 'Bihari languages',
    Value: 'BIH',
  },
  {
    Name: 'Bikol',
    Value: 'BIK',
  },
  {
    Name: 'Bini; Edo',
    Value: 'BIN',
  },
  {
    Name: 'Bislama',
    Value: 'BIS',
  },
  {
    Name: 'Blin; Bilin',
    Value: 'BYN',
  },
  {
    Name: 'Blissymbols; Blissymbolics; Bliss',
    Value: 'ZBL',
  },
  {
    Name: 'Bokmål, Norwegian; Norwegian Bokmål',
    Value: 'NOB',
  },
  {
    Name: 'Bosnian',
    Value: 'BOS',
  },
  {
    Name: 'Braj',
    Value: 'BRA',
  },
  {
    Name: 'Breton',
    Value: 'BRE',
  },
  {
    Name: 'Buginese',
    Value: 'BUG',
  },
  {
    Name: 'Bulgarian',
    Value: 'BUL',
  },
  {
    Name: 'Buriat',
    Value: 'BUA',
  },
  {
    Name: 'Burmese',
    Value: 'MYA',
  },
  {
    Name: 'Caddo',
    Value: 'CAD',
  },
  {
    Name: 'Catalan',
    Value: 'CAT',
  },
  {
    Name: 'Caucasian languages',
    Value: 'CAU',
  },
  {
    Name: 'Cebuano',
    Value: 'CEB',
  },
  {
    Name: 'Celtic languages',
    Value: 'CEL',
  },
  {
    Name: 'Central American Indian languages',
    Value: 'CAI',
  },
  {
    Name: 'Central Khmer',
    Value: 'KHM',
  },
  {
    Name: 'Chagatai',
    Value: 'CHG',
  },
  {
    Name: 'Chamic languages',
    Value: 'CMC',
  },
  {
    Name: 'Chamorro',
    Value: 'CHA',
  },
  {
    Name: 'Chechen',
    Value: 'CHE',
  },
  {
    Name: 'Cherokee',
    Value: 'CHR',
  },
  {
    Name: 'Cheyenne',
    Value: 'CHY',
  },
  {
    Name: 'Chhattisgarhi',
    Value: 'HNE',
  },
  {
    Name: 'Chibcha',
    Value: 'CHB',
  },
  {
    Name: 'Chichewa; Chewa; Nyanja',
    Value: 'NYA',
  },
  {
    Name: 'Chinese',
    Value: 'ZHO',
  },
  {
    Name: 'Chinook jargon',
    Value: 'CHN',
  },
  {
    Name: 'Chipewyan; Dene Suline',
    Value: 'CHP',
  },
  {
    Name: 'Chittagonian',
    Value: 'CTG',
  },
  {
    Name: 'Choctaw',
    Value: 'CHO',
  },
  {
    Name: 'Church Slavic; Old Slavonic; Church Slavonic; Old Bulgarian; Old Church Slavonic',
    Value: 'CHU',
  },
  {
    Name: 'Chuukese',
    Value: 'CHK',
  },
  {
    Name: 'Chuvash',
    Value: 'CHV',
  },
  {
    Name: 'Classical Newari; Old Newari; Classical Nepal Bhasa',
    Value: 'NWC',
  },
  {
    Name: 'Classical Syriac',
    Value: 'SYC',
  },
  {
    Name: 'Coptic',
    Value: 'COP',
  },
  {
    Name: 'Cornish',
    Value: 'COR',
  },
  {
    Name: 'Corsican',
    Value: 'COS',
  },
  {
    Name: 'Cree',
    Value: 'CRE',
  },
  {
    Name: 'Creek',
    Value: 'MUS',
  },
  {
    Name: 'Creoles and pidgins',
    Value: 'CRP',
  },
  {
    Name: 'Creoles and pidgins, English based',
    Value: 'CPE',
  },
  {
    Name: 'Creoles and pidgins, French-based',
    Value: 'CPF',
  },
  {
    Name: 'Creoles and pidgins, Portuguese-based',
    Value: 'CPP',
  },
  {
    Name: 'Crimean Tatar; Crimean Turkish',
    Value: 'CRH',
  },
  {
    Name: 'Croatian',
    Value: 'HRV',
  },
  {
    Name: 'Cushitic languages',
    Value: 'CUS',
  },
  {
    Name: 'Czech',
    Value: 'CES',
  },
  {
    Name: 'Dakota',
    Value: 'DAK',
  },
  {
    Name: 'Danish',
    Value: 'DAN',
  },
  {
    Name: 'Dargwa',
    Value: 'DAR',
  },
  {
    Name: 'Deccan',
    Value: 'DCC',
  },
  {
    Name: 'Delaware',
    Value: 'DEL',
  },
  {
    Name: 'Dinka',
    Value: 'DIN',
  },
  {
    Name: 'Divehi; Dhivehi; Maldivian',
    Value: 'DIV',
  },
  {
    Name: 'Dogri',
    Value: 'DOI',
  },
  {
    Name: 'Dogrib',
    Value: 'DGR',
  },
  {
    Name: 'Dravidian languages',
    Value: 'DRA',
  },
  {
    Name: 'Duala',
    Value: 'DUA',
  },
  {
    Name: 'Dutch',
    Value: 'NLD',
  },
  {
    Name: 'Dutch, Middle (ca.1050-1350)',
    Value: 'DUM',
  },
  {
    Name: 'Dyula',
    Value: 'DYU',
  },
  {
    Name: 'Dzongkha',
    Value: 'DZO',
  },
  {
    Name: 'Eastern Frisian',
    Value: 'FRS',
  },
  {
    Name: 'Efik',
    Value: 'EFI',
  },
  {
    Name: 'Egyptian (Ancient)',
    Value: 'EGY',
  },
  {
    Name: 'Ekajuk',
    Value: 'EKA',
  },
  {
    Name: 'Elamite',
    Value: 'ELX',
  },
  {
    Name: 'English',
    Value: 'ENG',
  },
  {
    Name: 'English, Middle (1100-1500)',
    Value: 'ENM',
  },
  {
    Name: 'English, Old (ca.450-1100)',
    Value: 'ANG',
  },
  {
    Name: 'Erzya',
    Value: 'MYV',
  },
  {
    Name: 'Esperanto',
    Value: 'EPO',
  },
  {
    Name: 'Estonian',
    Value: 'EST',
  },
  {
    Name: 'EWE',
    Value: 'EWE',
  },
  {
    Name: 'Ewondo',
    Value: 'EWO',
  },
  {
    Name: 'Fang',
    Value: 'FAN',
  },
  {
    Name: 'Fanti',
    Value: 'FAT',
  },
  {
    Name: 'Faroese',
    Value: 'FAO',
  },
  {
    Name: 'Fijian',
    Value: 'FIJ',
  },
  {
    Name: 'Filipino; Pilipino',
    Value: 'FIL',
  },
  {
    Name: 'Finnish',
    Value: 'FIN',
  },
  {
    Name: 'Finno-Ugrian languages',
    Value: 'FIU',
  },
  {
    Name: 'FON',
    Value: 'FON',
  },
  {
    Name: 'French',
    Value: 'FRA',
  },
  {
    Name: 'French, Middle (ca.1400-1600)',
    Value: 'FRM',
  },
  {
    Name: 'French, Old (842-ca.1400)',
    Value: 'FRO',
  },
  {
    Name: 'Friulian',
    Value: 'FUR',
  },
  {
    Name: 'Fulah',
    Value: 'FUL',
  },
  {
    Name: 'Ga',
    Value: 'GAA',
  },
  {
    Name: 'Gaelic; Scottish Gaelic',
    Value: 'GLA',
  },
  {
    Name: 'Galibi Carib',
    Value: 'CAR',
  },
  {
    Name: 'Galician',
    Value: 'GLG',
  },
  {
    Name: 'Ganda',
    Value: 'LUG',
  },
  {
    Name: 'Gayo',
    Value: 'GAY',
  },
  {
    Name: 'Gbaya',
    Value: 'GBA',
  },
  {
    Name: 'Geez',
    Value: 'GEZ',
  },
  {
    Name: 'Georgian',
    Value: 'KAT',
  },
  {
    Name: 'German',
    Value: 'DEU',
  },
  {
    Name: 'German, Middle High (ca.1050-1500)',
    Value: 'GMH',
  },
  {
    Name: 'German, Old High (ca.750-1050)',
    Value: 'GOH',
  },
  {
    Name: 'Germanic languages',
    Value: 'GEM',
  },
  {
    Name: 'Gilbertese',
    Value: 'GIL',
  },
  {
    Name: 'Gondi',
    Value: 'GON',
  },
  {
    Name: 'Gorontalo',
    Value: 'GOR',
  },
  {
    Name: 'Gothic',
    Value: 'GOT',
  },
  {
    Name: 'Grebo',
    Value: 'GRB',
  },
  {
    Name: 'Greek, Ancient (to 1453)',
    Value: 'GRC',
  },
  {
    Name: 'Greek, Modern (1453-)',
    Value: 'ELL',
  },
  {
    Name: 'Guarani',
    Value: 'GRN',
  },
  {
    Name: 'Gujarati',
    Value: 'GUJ',
  },
  {
    Name: "Gwich'in",
    Value: 'GWI',
  },
  {
    Name: 'Haida',
    Value: 'HAI',
  },
  {
    Name: 'Haitian; Haitian Creole',
    Value: 'HAT',
  },
  {
    Name: 'Haryanvi',
    Value: 'BGC',
  },
  {
    Name: 'Hausa',
    Value: 'HAU',
  },
  {
    Name: 'Hawaiian',
    Value: 'HAW',
  },
  {
    Name: 'Hebrew',
    Value: 'HEB',
  },
  {
    Name: 'Herero',
    Value: 'HER',
  },
  {
    Name: 'Hiligaynon',
    Value: 'HIL',
  },
  {
    Name: 'Himachali languages; Western Pahari languages',
    Value: 'HIM',
  },
  {
    Name: 'Hindi',
    Value: 'HIN',
  },
  {
    Name: 'Hiri Motu',
    Value: 'HMO',
  },
  {
    Name: 'Hittite',
    Value: 'HIT',
  },
  {
    Name: 'Hmong; Mong',
    Value: 'HMN',
  },
  {
    Name: 'Hungarian',
    Value: 'HUN',
  },
  {
    Name: 'Hupa',
    Value: 'HUP',
  },
  {
    Name: 'Iban',
    Value: 'IBA',
  },
  {
    Name: 'Icelandic',
    Value: 'ISL',
  },
  {
    Name: 'IDO',
    Value: 'IDO',
  },
  {
    Name: 'Igbo',
    Value: 'IBO',
  },
  {
    Name: 'Ijo languages',
    Value: 'IJO',
  },
  {
    Name: 'Iloko',
    Value: 'ILO',
  },
  {
    Name: 'Inari Sami',
    Value: 'SMN',
  },
  {
    Name: 'Indic languages',
    Value: 'INC',
  },
  {
    Name: 'Indo-European languages',
    Value: 'INE',
  },
  {
    Name: 'Indonesian',
    Value: 'IND',
  },
  {
    Name: 'Ingush',
    Value: 'INH',
  },
  {
    Name: 'Interlingua (International Auxiliary Language Association)',
    Value: 'INA',
  },
  {
    Name: 'Interlingue; Occidental',
    Value: 'ILE',
  },
  {
    Name: 'Inuktitut',
    Value: 'IKU',
  },
  {
    Name: 'Inupiaq',
    Value: 'IPK',
  },
  {
    Name: 'Iranian languages',
    Value: 'IRA',
  },
  {
    Name: 'Irish',
    Value: 'GLE',
  },
  {
    Name: 'Irish, Middle (900-1200)',
    Value: 'MGA',
  },
  {
    Name: 'Irish, Old (to 900)',
    Value: 'SGA',
  },
  {
    Name: 'Iroquoian languages',
    Value: 'IRO',
  },
  {
    Name: 'Italian',
    Value: 'ITA',
  },
  {
    Name: 'Japanese',
    Value: 'JPN',
  },
  {
    Name: 'Javanese',
    Value: 'JAV',
  },
  {
    Name: 'Judeo-Arabic',
    Value: 'JRB',
  },
  {
    Name: 'Judeo-Persian',
    Value: 'JPR',
  },
  {
    Name: 'Kabardian',
    Value: 'KBD',
  },
  {
    Name: 'Kabyle',
    Value: 'KAB',
  },
  {
    Name: 'Kachin; Jingpho',
    Value: 'KAC',
  },
  {
    Name: 'Kalaallisut; Greenlandic',
    Value: 'KAL',
  },
  {
    Name: 'Kalmyk; Oirat',
    Value: 'XAL',
  },
  {
    Name: 'Kamba',
    Value: 'KAM',
  },
  {
    Name: 'Kannada',
    Value: 'KAN',
  },
  {
    Name: 'Kanuri',
    Value: 'KAU',
  },
  {
    Name: 'Kara-Kalpak',
    Value: 'KAA',
  },
  {
    Name: 'Karachay-Balkar',
    Value: 'KRC',
  },
  {
    Name: 'Karelian',
    Value: 'KRL',
  },
  {
    Name: 'Karen languages',
    Value: 'KAR',
  },
  {
    Name: 'Kashmiri',
    Value: 'KAS',
  },
  {
    Name: 'Kashubian',
    Value: 'CSB',
  },
  {
    Name: 'Kawi',
    Value: 'KAW',
  },
  {
    Name: 'Kazakh',
    Value: 'KAZ',
  },
  {
    Name: 'Khasi',
    Value: 'KHA',
  },
  {
    Name: 'Khoisan languages',
    Value: 'KHI',
  },
  {
    Name: 'Khotanese; Sakan',
    Value: 'KHO',
  },
  {
    Name: 'Kikuyu; Gikuyu',
    Value: 'KIK',
  },
  {
    Name: 'Kimbundu',
    Value: 'KMB',
  },
  {
    Name: 'Kinyarwanda',
    Value: 'KIN',
  },
  {
    Name: 'Kirghiz; Kyrgyz',
    Value: 'KIR',
  },
  {
    Name: 'Klingon; tlhIngan-Hol',
    Value: 'TLH',
  },
  {
    Name: 'Komi',
    Value: 'KOM',
  },
  {
    Name: 'Kongo',
    Value: 'KON',
  },
  {
    Name: 'Konkani',
    Value: 'KOK',
  },
  {
    Name: 'Korean',
    Value: 'KOR',
  },
  {
    Name: 'Kosraean',
    Value: 'KOS',
  },
  {
    Name: 'Kpelle',
    Value: 'KPE',
  },
  {
    Name: 'Kru languages',
    Value: 'KRO',
  },
  {
    Name: 'Kuanyama; Kwanyama',
    Value: 'KUA',
  },
  {
    Name: 'Kumyk',
    Value: 'KUM',
  },
  {
    Name: 'Kurdish',
    Value: 'KUR',
  },
  {
    Name: 'Kurukh',
    Value: 'KRU',
  },
  {
    Name: 'Kutenai',
    Value: 'KUT',
  },
  {
    Name: 'Ladino',
    Value: 'LAD',
  },
  {
    Name: 'Lahnda',
    Value: 'LAH',
  },
  {
    Name: 'Lamba',
    Value: 'LAM',
  },
  {
    Name: 'Land Dayak languages',
    Value: 'DAY',
  },
  {
    Name: 'LAO',
    Value: 'LAO',
  },
  {
    Name: 'Latin',
    Value: 'LAT',
  },
  {
    Name: 'Latvian',
    Value: 'LAV',
  },
  {
    Name: 'Lezghian',
    Value: 'LEZ',
  },
  {
    Name: 'Limburgan; Limburger; Limburgish',
    Value: 'LIM',
  },
  {
    Name: 'Lingala',
    Value: 'LIN',
  },
  {
    Name: 'Lithuanian',
    Value: 'LIT',
  },
  {
    Name: 'Lojban',
    Value: 'JBO',
  },
  {
    Name: 'Lombard',
    Value: 'LMO',
  },
  {
    Name: 'Low German; Low Saxon; German, Low; Saxon, Low',
    Value: 'NDS',
  },
  {
    Name: 'Lower Sorbian',
    Value: 'DSB',
  },
  {
    Name: 'Lozi',
    Value: 'LOZ',
  },
  {
    Name: 'Luba-Katanga',
    Value: 'LUB',
  },
  {
    Name: 'Luba-Lulua',
    Value: 'LUA',
  },
  {
    Name: 'Luiseno',
    Value: 'LUI',
  },
  {
    Name: 'Lule Sami',
    Value: 'SMJ',
  },
  {
    Name: 'Lunda',
    Value: 'LUN',
  },
  {
    Name: 'Luo (Kenya and Tanzania)',
    Value: 'LUO',
  },
  {
    Name: 'Lushai',
    Value: 'LUS',
  },
  {
    Name: 'Luxembourgish',
    Value: 'LTZ',
  },
  {
    Name: 'Macedonian',
    Value: 'MKD',
  },
  {
    Name: 'Madurese',
    Value: 'MAD',
  },
  {
    Name: 'Magahi',
    Value: 'MAG',
  },
  {
    Name: 'Maithili',
    Value: 'MAI',
  },
  {
    Name: 'Makasar',
    Value: 'MAK',
  },
  {
    Name: 'Malagasy',
    Value: 'MLG',
  },
  {
    Name: 'Malay',
    Value: 'MSA',
  },
  {
    Name: 'Malayalam',
    Value: 'MAL',
  },
  {
    Name: 'Maltese',
    Value: 'MLT',
  },
  {
    Name: 'Manchu',
    Value: 'MNC',
  },
  {
    Name: 'Mandar',
    Value: 'MDR',
  },
  {
    Name: 'MandarinChinese',
    Value: 'CMN',
  },
  {
    Name: 'Mandingo',
    Value: 'MAN',
  },
  {
    Name: 'Manipuri',
    Value: 'MNI',
  },
  {
    Name: 'Manobo languages',
    Value: 'MNO',
  },
  {
    Name: 'Manx',
    Value: 'GLV',
  },
  {
    Name: 'Maori',
    Value: 'MRI',
  },
  {
    Name: 'Mapudungun; Mapuche',
    Value: 'ARN',
  },
  {
    Name: 'Marathi',
    Value: 'MAR',
  },
  {
    Name: 'Mari',
    Value: 'CHM',
  },
  {
    Name: 'Marshallese',
    Value: 'MAH',
  },
  {
    Name: 'Marwari',
    Value: 'MWR',
  },
  {
    Name: 'Masai',
    Value: 'MAS',
  },
  {
    Name: 'Mayan languages',
    Value: 'MYN',
  },
  {
    Name: 'Mende',
    Value: 'MEN',
  },
  {
    Name: "Mi'kmaq; Micmac",
    Value: 'MIC',
  },
  {
    Name: 'Minangkabau',
    Value: 'MIN',
  },
  {
    Name: 'Mirandese',
    Value: 'MWL',
  },
  {
    Name: 'Mohawk',
    Value: 'MOH',
  },
  {
    Name: 'Moksha',
    Value: 'MDF',
  },
  {
    Name: 'Mon-Khmer languages',
    Value: 'MKH',
  },
  {
    Name: 'Mongo',
    Value: 'LOL',
  },
  {
    Name: 'Mongolian',
    Value: 'MON',
  },
  {
    Name: 'Mossi',
    Value: 'MOS',
  },
  {
    Name: 'Multiple languages',
    Value: 'MUL',
  },
  {
    Name: 'Munda languages',
    Value: 'MUN',
  },
  {
    Name: "N'Ko",
    Value: 'NQO',
  },
  {
    Name: 'Nahuatl languages',
    Value: 'NAH',
  },
  {
    Name: 'Nauru',
    Value: 'NAU',
  },
  {
    Name: 'Navajo; Navaho',
    Value: 'NAV',
  },
  {
    Name: 'Ndebele, North; North Ndebele',
    Value: 'NDE',
  },
  {
    Name: 'Ndebele, South; South Ndebele',
    Value: 'NBL',
  },
  {
    Name: 'Ndonga',
    Value: 'NDO',
  },
  {
    Name: 'Neapolitan',
    Value: 'NAP',
  },
  {
    Name: 'Nepal Bhasa; Newari',
    Value: 'NEW',
  },
  {
    Name: 'Nepali',
    Value: 'NEP',
  },
  {
    Name: 'Nias',
    Value: 'NIA',
  },
  {
    Name: 'Niger-Kordofanian languages',
    Value: 'NIC',
  },
  {
    Name: 'Nilo-Saharan languages',
    Value: 'SSA',
  },
  {
    Name: 'Niuean',
    Value: 'NIU',
  },
  {
    Name: 'No linguistic content; Not applicable',
    Value: 'ZXX',
  },
  {
    Name: 'Nogai',
    Value: 'NOG',
  },
  {
    Name: 'Norse, Old',
    Value: 'NON',
  },
  {
    Name: 'North American Indian languages',
    Value: 'NAI',
  },
  {
    Name: 'Northern Frisian',
    Value: 'FRR',
  },
  {
    Name: 'Northern Sami',
    Value: 'SME',
  },
  {
    Name: 'Norwegian',
    Value: 'NOR',
  },
  {
    Name: 'Norwegian Nynorsk; Nynorsk, Norwegian',
    Value: 'NNO',
  },
  {
    Name: 'Nubian languages',
    Value: 'NUB',
  },
  {
    Name: 'Nyamwezi',
    Value: 'NYM',
  },
  {
    Name: 'Nyankole',
    Value: 'NYN',
  },
  {
    Name: 'Nyoro',
    Value: 'NYO',
  },
  {
    Name: 'Nzima',
    Value: 'NZI',
  },
  {
    Name: 'Occitan (post 1500)',
    Value: 'OCI',
  },
  {
    Name: 'Official Aramaic (700-300 BCE); Imperial Aramaic (700-300 BCE)',
    Value: 'ARC',
  },
  {
    Name: 'Ojibwa',
    Value: 'OJI',
  },
  {
    Name: 'Oriya',
    Value: 'ORI',
  },
  {
    Name: 'Oromo',
    Value: 'ORM',
  },
  {
    Name: 'Osage',
    Value: 'OSA',
  },
  {
    Name: 'Ossetian; Ossetic',
    Value: 'OSS',
  },
  {
    Name: 'Otomian languages',
    Value: 'OTO',
  },
  {
    Name: 'Pahlavi',
    Value: 'PAL',
  },
  {
    Name: 'Palauan',
    Value: 'PAU',
  },
  {
    Name: 'Pali',
    Value: 'PLI',
  },
  {
    Name: 'Pampanga; Kapampangan',
    Value: 'PAM',
  },
  {
    Name: 'Pangasinan',
    Value: 'PAG',
  },
  {
    Name: 'Panjabi',
    Value: 'PAN',
  },
  {
    Name: 'Papiamento',
    Value: 'PAP',
  },
  {
    Name: 'Papuan languages',
    Value: 'PAA',
  },
  {
    Name: 'Pedi; Sepedi; Northern Sotho',
    Value: 'NSO',
  },
  {
    Name: 'Persian',
    Value: 'FAS',
  },
  {
    Name: 'Persian, Old (ca.600-400 B.C.)',
    Value: 'PEO',
  },
  {
    Name: 'Philippine languages',
    Value: 'PHI',
  },
  {
    Name: 'Phoenician',
    Value: 'PHN',
  },
  {
    Name: 'Pohnpeian',
    Value: 'PON',
  },
  {
    Name: 'Polish',
    Value: 'POL',
  },
  {
    Name: 'Portuguese',
    Value: 'POR',
  },
  {
    Name: 'Prakrit languages',
    Value: 'PRA',
  },
  {
    Name: 'Provençal, Old (to 1500); Occitan, Old (to 1500)',
    Value: 'PRO',
  },
  {
    Name: 'Pushto; Pashto',
    Value: 'PUS',
  },
  {
    Name: 'Quechua',
    Value: 'QUE',
  },
  {
    Name: 'Rajasthani',
    Value: 'RAJ',
  },
  {
    Name: 'Rapanui',
    Value: 'RAP',
  },
  {
    Name: 'Rarotongan; Cook Islands Maori',
    Value: 'RAR',
  },
  {
    Name: 'Romance languages',
    Value: 'ROA',
  },
  {
    Name: 'Romanian',
    Value: 'RON',
  },
  {
    Name: 'Romansh',
    Value: 'ROH',
  },
  {
    Name: 'Romany',
    Value: 'ROM',
  },
  {
    Name: 'Rundi',
    Value: 'RUN',
  },
  {
    Name: 'Russian',
    Value: 'RUS',
  },
  {
    Name: 'Salishan languages',
    Value: 'SAL',
  },
  {
    Name: 'Samaritan Aramaic',
    Value: 'SAM',
  },
  {
    Name: 'Sami languages',
    Value: 'SMI',
  },
  {
    Name: 'Samoan',
    Value: 'SMO',
  },
  {
    Name: 'Sandawe',
    Value: 'SAD',
  },
  {
    Name: 'Sango',
    Value: 'SAG',
  },
  {
    Name: 'Sanskrit',
    Value: 'SAN',
  },
  {
    Name: 'Santali',
    Value: 'SAT',
  },
  {
    Name: 'Sardinian',
    Value: 'SRD',
  },
  {
    Name: 'Sasak',
    Value: 'SAS',
  },
  {
    Name: 'Scots',
    Value: 'SCO',
  },
  {
    Name: 'Selkup',
    Value: 'SEL',
  },
  {
    Name: 'Semitic languages',
    Value: 'SEM',
  },
  {
    Name: 'Serbian',
    Value: 'SRP',
  },
  {
    Name: 'Serer',
    Value: 'SRR',
  },
  {
    Name: 'Shan',
    Value: 'SHN',
  },
  {
    Name: 'Shona',
    Value: 'SNA',
  },
  {
    Name: 'Sichuan Yi; Nuosu',
    Value: 'III',
  },
  {
    Name: 'Sicilian',
    Value: 'SCN',
  },
  {
    Name: 'Sidamo',
    Value: 'SID',
  },
  {
    Name: 'Sign Languages',
    Value: 'SGN',
  },
  {
    Name: 'Siksika',
    Value: 'BLA',
  },
  {
    Name: 'Sindhi',
    Value: 'SND',
  },
  {
    Name: 'Sinhala',
    Value: 'SIN',
  },
  {
    Name: 'Sino-Tibetan languages',
    Value: 'SIT',
  },
  {
    Name: 'Siouan languages',
    Value: 'SIO',
  },
  {
    Name: 'Skolt Sami',
    Value: 'SMS',
  },
  {
    Name: 'Slave (Athapascan)',
    Value: 'DEN',
  },
  {
    Name: 'Slavic languages',
    Value: 'SLA',
  },
  {
    Name: 'Slovak',
    Value: 'SLK',
  },
  {
    Name: 'Slovenian',
    Value: 'SLV',
  },
  {
    Name: 'Sogdian',
    Value: 'SOG',
  },
  {
    Name: 'Somali',
    Value: 'SOM',
  },
  {
    Name: 'Songhai languages',
    Value: 'SON',
  },
  {
    Name: 'Soninke',
    Value: 'SNK',
  },
  {
    Name: 'Sorbian languages',
    Value: 'WEN',
  },
  {
    Name: 'Sotho, Southern',
    Value: 'SOT',
  },
  {
    Name: 'South American Indian languages',
    Value: 'SAI',
  },
  {
    Name: 'Southern Altai',
    Value: 'ALT',
  },
  {
    Name: 'Southern Sami',
    Value: 'SMA',
  },
  {
    Name: 'Spanish',
    Value: 'SPA',
  },
  {
    Name: 'Sranan Tongo',
    Value: 'SRN',
  },
  {
    Name: 'Standard Moroccan Tamazight',
    Value: 'ZGH',
  },
  {
    Name: 'Sukuma',
    Value: 'SUK',
  },
  {
    Name: 'Sumerian',
    Value: 'SUX',
  },
  {
    Name: 'Sundanese',
    Value: 'SUN',
  },
  {
    Name: 'Susu',
    Value: 'SUS',
  },
  {
    Name: 'Swahili',
    Value: 'SWA',
  },
  {
    Name: 'Swati',
    Value: 'SSW',
  },
  {
    Name: 'Swedish',
    Value: 'SWE',
  },
  {
    Name: 'Swiss German; Alemannic; Alsatian',
    Value: 'GSW',
  },
  {
    Name: 'Syriac',
    Value: 'SYR',
  },
  {
    Name: 'Tagalog',
    Value: 'TGL',
  },
  {
    Name: 'Tahitian',
    Value: 'TAH',
  },
  {
    Name: 'Tai languages',
    Value: 'TAI',
  },
  {
    Name: 'Tajik',
    Value: 'TGK',
  },
  {
    Name: 'Tamashek',
    Value: 'TMH',
  },
  {
    Name: 'Tamil',
    Value: 'TAM',
  },
  {
    Name: 'Tatar',
    Value: 'TAT',
  },
  {
    Name: 'Telugu',
    Value: 'TEL',
  },
  {
    Name: 'Tereno',
    Value: 'TER',
  },
  {
    Name: 'Tetum',
    Value: 'TET',
  },
  {
    Name: 'Thai',
    Value: 'THA',
  },
  {
    Name: 'Tibetan',
    Value: 'BOD',
  },
  {
    Name: 'Tigre',
    Value: 'TIG',
  },
  {
    Name: 'Tigrinya',
    Value: 'TIR',
  },
  {
    Name: 'Timne',
    Value: 'TEM',
  },
  {
    Name: 'TIV',
    Value: 'TIV',
  },
  {
    Name: 'Tlingit',
    Value: 'TLI',
  },
  {
    Name: 'Tok Pisin',
    Value: 'TPI',
  },
  {
    Name: 'Tokelau',
    Value: 'TKL',
  },
  {
    Name: 'Tonga (Nyasa)',
    Value: 'TOG',
  },
  {
    Name: 'Tonga (Tonga Islands)',
    Value: 'TON',
  },
  {
    Name: 'Tsimshian',
    Value: 'TSI',
  },
  {
    Name: 'Tsonga',
    Value: 'TSO',
  },
  {
    Name: 'Tswana',
    Value: 'TSN',
  },
  {
    Name: 'Tumbuka',
    Value: 'TUM',
  },
  {
    Name: 'Tupi languages',
    Value: 'TUP',
  },
  {
    Name: 'Turkish',
    Value: 'TUR',
  },
  {
    Name: 'Turkish, Ottoman (1500-1928)',
    Value: 'OTA',
  },
  {
    Name: 'Turkmen',
    Value: 'TUK',
  },
  {
    Name: 'Tuvalu',
    Value: 'TVL',
  },
  {
    Name: 'Tuvinian',
    Value: 'TYV',
  },
  {
    Name: 'TWI',
    Value: 'TWI',
  },
  {
    Name: 'Udmurt',
    Value: 'UDM',
  },
  {
    Name: 'Ugaritic',
    Value: 'UGA',
  },
  {
    Name: 'Uighur; Uyghur',
    Value: 'UIG',
  },
  {
    Name: 'Ukrainian',
    Value: 'UKR',
  },
  {
    Name: 'Umbundu',
    Value: 'UMB',
  },
  {
    Name: 'Uncoded languages',
    Value: 'MIS',
  },
  {
    Name: 'Undetermined',
    Value: 'UND',
  },
  {
    Name: 'Upper Sorbian',
    Value: 'HSB',
  },
  {
    Name: 'Urdu',
    Value: 'URD',
  },
  {
    Name: 'Uzbek',
    Value: 'UZB',
  },
  {
    Name: 'VAI',
    Value: 'VAI',
  },
  {
    Name: 'Venda',
    Value: 'VEN',
  },
  {
    Name: 'Vietnamese',
    Value: 'VIE',
  },
  {
    Name: 'Volapük',
    Value: 'VOL',
  },
  {
    Name: 'Votic',
    Value: 'VOT',
  },
  {
    Name: 'Wakashan languages',
    Value: 'WAK',
  },
  {
    Name: 'Walloon',
    Value: 'WLN',
  },
  {
    Name: 'Waray',
    Value: 'WAR',
  },
  {
    Name: 'Washo',
    Value: 'WAS',
  },
  {
    Name: 'Welsh',
    Value: 'CYM',
  },
  {
    Name: 'Western Frisian',
    Value: 'FRY',
  },
  {
    Name: 'Wolaitta; Wolaytta',
    Value: 'WAL',
  },
  {
    Name: 'Wolof',
    Value: 'WOL',
  },
  {
    Name: 'Xhosa',
    Value: 'XHO',
  },
  {
    Name: 'Yakut',
    Value: 'SAH',
  },
  {
    Name: 'YAO',
    Value: 'YAO',
  },
  {
    Name: 'Yapese',
    Value: 'YAP',
  },
  {
    Name: 'Yiddish',
    Value: 'YID',
  },
  {
    Name: 'Yoruba',
    Value: 'YOR',
  },
  {
    Name: 'Yupik languages',
    Value: 'YPK',
  },
  {
    Name: 'Zande languages',
    Value: 'ZND',
  },
  {
    Name: 'Zapotec',
    Value: 'ZAP',
  },
  {
    Name: 'Zaza; Dimili; Dimli; Kirdki; Kirmanjki; Zazaki',
    Value: 'ZZA',
  },
  {
    Name: 'Zenaga',
    Value: 'ZEN',
  },
  {
    Name: 'Zhuang; Chuang',
    Value: 'ZHA',
  },
  {
    Name: 'Zulu',
    Value: 'ZUL',
  },
  {
    Name: 'Zuni',
    Value: 'ZUN',
  },
];
